import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "AppBackground" }

import useGlobalStateStore from "@/Store/GlobalStateStore";
import {ref, watch} from "vue";

enum Enum_Theme {
  Dark,
  Light,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "v5929d7ac": (ThemeBackgroundColor.value)
}))

const GlobalStyleStore=useGlobalStateStore();
const ThemeBackgroundColor = ref("#202020");

watch(GlobalStyleStore, () => {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark){
    ThemeBackgroundColor.value = '#202020';
  }else{
    ThemeBackgroundColor.value = '#fff';
  }
});




return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})